export default "__VITE_ASSET__DxKi2L8A__"